/* eslint-disable security/detect-object-injection */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import TopHeader from "../../../components/TopHeader";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import {
  useParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import CustomOverLay from "../../../components/CustomOverLay";
import GlobalContext from "../../../components/Context/GloablContext";
import SearchEmptyScreen from "../../../components/SearchEmptyScreen";
import {
  useGetProvidersQuery,
  useGetAlertProviderQuery,
  useViewPatientQuery,
  useGetPatientWellnessDetailsQuery,
} from "../../../slices/patientSlice";
import ProviderTable from "../ProviderList/Table";
import Limit from "../../../components/Limit";
import Pagination from "../../../components/Pagination";
import Emptyscreen from "../../../components/EmptyScreen";
import ProviderAlertTable from "../ProviderAlertList/Table";
import FilterProviderAlertBtn from "../ProviderAlertList/Table/Filter";
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import moment from "moment";
import { handleAddFilterValues } from "../../../redux/systemConfigSlice";
import Graphs from "../Graphs";
import HistoricalData from "../DeviceReadingHistory/Components";
import { dataService } from "../../../services/data.services";
import DeviceAlertList from "../AlertsList";
import HelpGuideModal from "../../../components/HelpGuideModal";
import { useGetHelpGuideProviderQuery } from "../../../slices/patientSlice";
import PermissionErrorEmptyScreen from "../../../components/Emptyscreenwithouttitle/PermissionErrorEmptyScreen";
import { organizationusersList } from "../../../slices/apiSlice";
import { resetDeviceAlertDashboardSearch } from "../../../redux/deviceAleartDashboardSlice";

export default function ViewProvider() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchParamsAlert, setSearchParamsAlert] = useSearchParams();
  // Extract the patient ID from the pathname
  const viewId = location?.pathname?.split("/")?.[3];

  // Use the query hook with the correct query string
  const {
    data: patientData,
    status: patientStatus,
    error: patientError,
    isfetching: patientDetailsFetching,
  } = useViewPatientQuery(viewId);

  const {
    data: wellnessDetails,
    isFetching,
    status: wellnessStatus,
    error: wellnessError,
  } = useGetPatientWellnessDetailsQuery(location?.pathname?.split("/")?.[4]);
  const { isSideBar, setToastmessage, setToastErrorMessage, setIsSearchOpen } =
    useContext(GlobalContext);
  const [helpGuideModel, setHelpGuideModel] = useState(false);
  const [triggerApiCall, setTriggerApiCall] = useState(false);
  const [queryParamsorg, setQueryParamsorg] = useState("");
  const userType = sessionStorage.getItem("user_type");

  const { data: helpguidedata, status: helpguidestatus } =
    useGetHelpGuideProviderQuery(queryParamsorg, {
      skip: !triggerApiCall, // Skip the query until the trigger is set to true
    });

  const dispatch = useDispatch();
  const [isColumnSelect, setIsColumnSelect] = useState(false);
  const filtervals = useSelector((state) => state.systemConfigData.filterState);
  const { id, pateint_id } = useParams();
  const [isSortselected, setisSortSelected] = useState(false);
  const [isAlertSortselected, setisAlertSortSelected] = useState(false);
  const [limit, setLimit] = useState("15");
  const [skip, setSkip] = useState(true);
  const [suggestions, setSuggestions] = useState("");
  const [patientTabName, setPatientTabName] = useState(() => {
    return searchParams.get("tabname") || "Graphs"; // Default to 'Graphs' only if tabname is missing
  });
  const patientId =
    searchParams?.get("patient_id") !== null
      ? searchParams?.get("patient_id")
      : location.pathname.split("/")?.[4];
  const outSideClick = useRef();
  const [dateError, setdateError] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const initialState = {
    filter_start_date: "",
    filter_end_date: "",
  };
  const [filterValues, setFilterValues] = useState(initialState);
  const user_Type = sessionStorage.getItem("user_type");
  const [graphDetails, setGraphDetails] = useState([]);
  const [graphLoader, setGraphLoader] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filterDate, setFilterDate] = useState(null); // State to hold the filtered date
  const [isStateLoading, setIsStateLoading] = useState(false);
  const [historicalDataLoading, setHistoricalDataLoading] = useState(false);

  var currentTimeInMillisUTC = Date.now();

  // Convert milliseconds to seconds (divide by 1000)
  var currentTimeInSeconds = Math.floor(currentTimeInMillisUTC / 1000);
  // provider list api
  let queryStringProviders = `patient_id=${patientId}`;
  let sortValue = "";

  // Check if other search parameters exist and append them to the query string
  if (searchParams) {
    searchParams.forEach((value, key) => {
      if (key === "user_id" || key === "first_name" || key === "last_name") {
        // Append user_id, first_name, and last_name parameters directly
        queryStringProviders += `&${key}=${encodeURIComponent(value)}`;
      } else if (key === "sort" && !value.includes("acknowledged_last_name")) {
        // Construct the sort value excluding acknowledged_last_name
        sortValue = encodeURIComponent(value);
      }
    });
  }

  // Add the sort parameter to the query string if it's not empty and doesn't include acknowledged_last_name
  if (sortValue && !sortValue.includes("acknowledged_last_name")) {
    queryStringProviders += `&sort=${sortValue}`;
  }

  // Add page_number and limit parameters
  queryStringProviders += `&page_number=${
    searchParams?.get("page_number") || "1"
  }`;
  queryStringProviders += `&limit=${searchParams?.get("limit") || "15"}`;

  const {
    data,
    isFetching: providerlistfetch,
    isLoading: providerloading,
    status: providerstatus,
    refetch: refetchProvider,
  } = useGetProvidersQuery(queryStringProviders, {
    skip: user_Type !== "monitor-user",
  });
  // provider alert api
  let queryStringAlertProviders = `patient_id=${patientId}`;
  let sortValueAlert = "";
  let filterValue = "";

  // Check if other search parameters exist and append them to the query string
  if (searchParamsAlert) {
    searchParamsAlert.forEach((value, key) => {
      if (key === "sort" && value.includes("acknowledged_last_name")) {
        // Include acknowledged_last_name for sort
        sortValueAlert = encodeURIComponent(value);
      } else if (key === "filter") {
        // Include filter parameter
        filterValue = encodeURIComponent(value);
      } else if (
        key !== "sort" &&
        key !== "page_number" &&
        key !== "limit" &&
        key !== "tabname"
      ) {
        // Append other parameters directly except 'sort', 'page_number', and 'limit'
        queryStringAlertProviders += `&${key}=${encodeURIComponent(value)}`;
      }
    });
  }

  // Add the sort parameter to the query string if it's not empty
  if (sortValueAlert) {
    queryStringAlertProviders += `&sort=${sortValueAlert}`;
  }

  // Add the filter parameter to the query string if it's not empty
  if (filterValue) {
    queryStringAlertProviders += `&filter=${filterValue}`;
  }

  // Add page_number and limit parameters
  queryStringAlertProviders += `&page_number=${
    searchParams?.get("page_number") || "1"
  }`;
  queryStringAlertProviders += `&limit=${searchParams?.get("limit") || "15"}`;

  // Now, queryStringAlertProviders contains all the parameters including sort if applied
  const {
    data: providerData,
    isFetching: provideralertfetching,
    isLoading: provideralertloading,
    status: provideralertstatus,
    refetch,
  } = useGetAlertProviderQuery(queryStringAlertProviders, {
    skip: user_Type !== "monitor-user" || patientTabName !== "provider_alerts",
  });

  // On mount, check search params and set the active tab
  useEffect(() => {
    const tabFromParams = searchParams.get("tabname") || "Graphs";
    setPatientTabName(tabFromParams);
  }, [searchParams]); // Runs whenever searchParams change

  const handleTabChange = (tabName) => {
    let params = Object.fromEntries(searchParams);
    params.page_number = "1";
    params.limit = "15";
    params.tabname = tabName;
    setPatientTabName(tabName);

    if (tabName === "Graphs" && patientData !== undefined) {
      handleFetchGraphDetials(patientData?.[0]?.patient_id);
    }

    setIsSearchOpen(false);
    dispatch(resetDeviceAlertDashboardSearch());

    if (tabName !== "device_alerts") {
      if (params.type !== "") {
        delete params.type;
      }
      if (params.reading_type !== "") {
        delete params.reading_type;
      }
      if (params.patient_id !== "") {
        delete params.patient_id;
      }
      if (params.tabname !== "") {
        delete params.tabname;
      }
      if (params.search_mode !== "") {
        delete params.search_mode;
      }
      if (params.search !== "") {
        delete params.search;
      }
      dispatch(resetDeviceAlertDashboardSearch());
      setIsSearchOpen(false);
    }
    setSearchParams({ ...params });
  };

  const fetchDataBasedOnTab = () => {
    // Your data fetching logic based on the selected tab (patientTabName)
    if (
      patientTabName === "provider_alerts" &&
      patientTabName !== "device_alerts"
    ) {
      refetch(); // Automatically refetches data for provider alerts
    } else if (patientTabName === "provider_list" || isSortselected) {
      refetchProvider(); // Automatically refetches data for provider list
    }
  };

  useEffect(() => {
    // Fetch data based on the selected tab when component mounts or tab changes
    fetchDataBasedOnTab();
  }, [patientTabName]);

  const handleSelectDate = (id, date, dateString, termkey) => {
    setSelectedDate(dateString);
    setFilterDate(dateString);
  };

  const previousDay = () => {
    const date = filterDate
      ? new Date(filterDate)
      : selectedDate === ""
      ? new Date()
      : new Date(selectedDate); // If filterDate exists, use it, else use current date
    date.setDate(date.getDate() - 1); // Subtract 1 day
    const epochDate = Math.floor(date.getTime() / 1000);
    setSelectedDate(epochDate);
    if (filterDate) {
      setFilterDate(date.toISOString().slice(0, 10)); // Update filterDate state if filterDate exists
    }
    setSelectedDate(date.toISOString().slice(0, 10));
  };

  // Function to handle next day
  const nextDay = () => {
    const date = filterDate
      ? new Date(filterDate)
      : selectedDate === ""
      ? new Date()
      : new Date(selectedDate); // If filterDate exists, use it, else use current date
    date.setDate(date.getDate() + 1); // Add 1 day
    const epochDate = Math.floor(date.getTime() / 1000);
    if (filterDate) {
      setFilterDate(date.toISOString().slice(0, 10)); // Update filterDate state if filterDate exists
    }
    setSelectedDate(date.toISOString().slice(0, 10));
  };

  /**
   * The `handleTodayClick` function sets the selected date to the current date using Moment.js.
   */
  const handleTodayClick = () => {
    const today = moment();
    setSelectedDate(today);
  };

  const handleFetchGraphDetials = useCallback(
    async (patientId) => {
      setGraphLoader(true);
      let endpoint;
      if (selectedDate !== "") {
        endpoint = `api-listener/patient/${patientId}?filter=true&day=${moment(
          selectedDate
        ).format("YYYY-MM-DD")}&current_date=${currentTimeInSeconds}`;
        // endpoint = `api-listener/patient/${patientId}?filter=true&start_date=${Math.floor(Date.parse(moment(selectedDate).format('YYYY-MM-DD')) / 86400000)*86400}&current_date=${currentTimeInSeconds}`
      } else {
        endpoint = `api-listener/patient/${patientId}?filter=false&start_date=${currentTimeInSeconds}`;
      }
      try {
        const response = await dataService.GetAPI(endpoint);

        if (response.error === false) {
          setGraphDetails(response?.data?.data?.data);
          setGraphLoader(false);
        } else {
          setGraphLoader(false);
        }
      } catch (e) {
        setGraphLoader(false);
      }
    },
    [selectedDate]
  ); // handleSelectDate is added as a dependency

  useEffect(() => {
    patientData !== undefined && handleFetchGraphDetials(patientId);
  }, [handleFetchGraphDetials, selectedDate, patientData]);

  const handleSearchParams = (key, value) => {
    let params = Object.fromEntries(searchParams);
    params.page_number = 1;
    params[key] = value;
    setSearchParams({ ...params });
    setSearchParamsAlert({ ...params });
  };

  const handleOnClickPageNumber = (pageNum) => {
    setisSortSelected(false);
    setisAlertSortSelected(false);
    const params = Object.fromEntries(searchParams || searchParamsAlert);
    setSearchParams({ ...params, page_number: pageNum });
    setSearchParamsAlert({ ...params, page_number: pageNum });
  };

  useEffect(() => {
    if (searchParams.size >= 3 || searchParamsAlert.size >= 3) {
      setSkip(false);
    } else {
      setSkip(true);
    }
    if (
      location.state !== null &&
      location.state !== "" &&
      location?.state?.limit !== undefined &&
      !Array.isArray(location.state)
    ) {
      let params = {
        limit: location.state.limit,
        page_number: location.state.page_number,
      };
      setSearchParams({ ...params });
      setSearchParamsAlert({ ...params });
    } else {
      if (!searchParams?.get("limit")) {
        handleSearchParams("limit", "15");
      }
      if (!searchParams?.get("page_number")) {
        handleSearchParams("page_number", "1");
      }
    }
  }, [location, searchParams, searchParamsAlert]);

  useOnClickOutside(outSideClick, () => {
    setIsFilterOpen(false);
  });

  useEffect(() => {
    const isManageDashboard = location?.pathname?.includes("manage-dashboard");

    if (patientTabName === "provider_alerts") {
      setQueryParamsorg(
        isManageDashboard
          ? "type=monitor-dashboard-provider-alerts"
          : "type=monitor-provider-alerts"
      );
    } else {
      setQueryParamsorg(
        isManageDashboard
          ? "type=monitor-dashboard-provider-list"
          : "type=monitor-provider-list"
      );
    }
  }, [patientTabName, location]);

  useEffect(() => {
    if (queryParamsorg) {
      setTriggerApiCall(true); // Allow the query to run
    }
  }, [queryParamsorg]);

  /**
   * The function `handleOpenFilter` toggles the visibility of a filter based on certain conditions.
   */
  const handleOpenFilter = () => {
    setdateError(false);
    if (
      (searchParams.get("start_date") !== null ||
        searchParams.get("end_date") !== null) &&
      !isFilterOpen
    ) {
      setFilterValues(filtervals);
    } else if (
      searchParams.get("start_date") === null &&
      searchParams.get("end_date") === null
    ) {
      setFilterValues({
        filter_start_date: "",
        filter_end_date: "",
      });
    }
    setIsFilterOpen(!isFilterOpen);
  };

  /**
   * The function `handleApplyFilter` updates search parameters based on filter values and type in a
   * React application.
   */
  const handleApplyFilter = (type) => {
    let params = Object.fromEntries(searchParams);
    const start_date = moment(filterValues.filter_start_date).format(
      "YYYY-MM-DD"
    );
    const end_date = moment(filterValues.filter_end_date).format("YYYY-MM-DD");
    dispatch(
      handleAddFilterValues({
        filter_start_date: filterValues.filter_start_date,
        filter_end_date: filterValues.filter_end_date,
      })
    );
    if (type) {
      (params.filter = true),
        (params.page_number = "1"),
        filterValues.filter_start_date !== ""
          ? (params["start_date"] =
              Math.floor(Date.parse(start_date) / 86400000) * 86400)
          : "";
      filterValues.filter_end_date !== ""
        ? (params["end_date"] =
            Math.floor(Date.parse(end_date) / 86400000) * 86400 + 86399)
        : "";
      setSearchParams({ ...params });
    } else {
      params.start_date && delete params.start_date;
      params.end_date && delete params.end_date;
      params.filter && delete params.filter,
        params.page_number && delete params.page_number,
        setSearchParams({ ...params });
    }
  };

  function handleNoOfRowsClick(number) {
    let params = Object.fromEntries(searchParamsAlert);
    params.page_number = 1;
    params["limit"] = number;
    setSearchParamsAlert({ ...params });
  }

  //this function is for disabling the other tabs when any one of the tabs is selected
  useEffect(() => {
    if (patientTabName === "provider_list" && providerstatus !== "fulfilled") {
      setIsStateLoading(true);
    } else if (
      patientTabName === "provider_alerts" &&
      provideralertstatus !== "fulfilled"
    ) {
      setIsStateLoading(true);
    } else {
      setIsStateLoading(false);
    }
  }, [providerstatus, provideralertstatus, patientTabName]);

  return (
      <>
          <div className="bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden">
              <TopHeader title={"Manage Patients"} />
              <>
                  {isFetching && patientStatus !== "fufilled" ? (
                      <CustomOverLay
                          Active
                          text="Loading Patient Details..."
                          classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${
                isSideBar ? "opened-sidebar-config" : "system_config_overlay"
              }`}
            />
          ) : patientStatus === "rejected" || wellnessStatus === "rejected" ? (
            wellnessError?.status === 401 ? (
                <div className="bg-white rounded-lg py-[12px] px-[30px] h-customh3">
                    <PermissionErrorEmptyScreen
                        message="You don't have access to the organization or subdivision"
                        height="h-full"
                />
                </div>
            ) : (
                <SearchEmptyScreen text="No data found" />
            )
          ) : (
              <div className="rounded-lg h-customh3">
                  <motion.div
                      className="mt-1"
                      animate={{ x: 0 }}
                      initial={{ x: -10 }}
                      transition={{ duration: 0.5 }}
              >
                      <div>
                          <div>
                              <div className="mx-7 flex justify-between items-end h-12">
                                  <div className="flex pb-2 overflow-x-auto overflow-y-visible scrollBar-hidden border-b border-[#E7CBD2] w-full mr-6">
                                      <button
                                          onClick={() => {
                            if (
                              !isStateLoading &&
                              !graphLoader &&
                              !historicalDataLoading
                            ) {
                              handleTabChange("Graphs");
                              setSearchParams("tabname=Graphs");
                            }
                          }}
                                          disabled={
                            isStateLoading ||
                            graphLoader ||
                            historicalDataLoading
                          }
                                          className={`px-2 pt-2.5 min-w-fit text-base font-semibold ${
                            patientTabName === "Graphs"
                              ? "text-[#972E4C]"
                              : "text-[##030E06] "
                          } relative ${
                            patientTabName === "Graphs" ? "patient_tab" : ""
                          }`}
                        >
                                          Graphs
                                      </button>
                                      {user_Type === "monitor-user" && (
                                      <>
                                          <button
                                              id={"device_alerts"}
                                              data-testid={"device_alerts"}
                                              disabled={isStateLoading}
                                              onClick={() => {
                                handleTabChange("device_alerts");
                                setSearchParams("tabname=device_alerts");
                              }}
                                              className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${
                                patientTabName === "device_alerts"
                                  ? "text-[#972E4C]"
                                  : "text-[##030E06] "
                              } relative ${
                                patientTabName === "device_alerts"
                                  ? "patient_tab"
                                  : ""
                              }`}
                            >
                                              Device Alerts
                                          </button>
                                          <button
                                              id={"provider_alerts"}
                                              disabled={isStateLoading}
                                              onClick={() => {
                                handleTabChange("provider_alerts");
                                setSearchParams("tabname=provider_alerts");
                              }}
                                              className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${
                                patientTabName === "provider_alerts"
                                  ? "text-[#972E4C]"
                                  : "text-[##030E06] "
                              } relative ${
                                patientTabName === "provider_alerts"
                                  ? "patient_tab"
                                  : ""
                              }`}
                            >
                                              Provider Alerts
                                          </button>
                                          <button
                                              id={"provider_list"}
                                              disabled={isStateLoading}
                                              onClick={() => {
                                handleTabChange("provider_list");
                                setSearchParams("tabname=provider_list");
                              }}
                                              className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${
                                patientTabName === "provider_list"
                                  ? "text-[#972E4C]"
                                  : "text-[##030E06] "
                              } relative ${
                                patientTabName === "provider_list"
                                  ? "patient_tab"
                                  : ""
                              }`}
                            >
                                              Provider List
                                          </button>
                                      </>
                        )}

                                      {user_Type !== "monitor-user" && (
                                      <button
                                          disabled={historicalDataLoading || graphLoader}
                                          id={"historical_data"}
                                          data-testid="historical_data"
                                          onClick={() => {
                              if (
                                !isStateLoading &&
                                !graphLoader &&
                                !historicalDataLoading
                              ) {
                                handleTabChange("historical_data");
                                setSearchParams("tabname=historical_data");
                              }
                            }}
                                          className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${
                              patientTabName === "historical_data"
                                ? "text-[#972E4C]"
                                : "text-[##030E06] "
                            } relative ${
                              patientTabName === "historical_data"
                                ? "patient_tab"
                                : ""
                            }`}
                          >
                                          Historical Data
                                      </button>
                        )}
                                  </div>
                                  <div>
                                      <button
                                          type="button"
                                          id="viewDetails"
                                          onClick={() => {
                            dispatch(
                              organizationusersList.util.resetApiState()
                            );
                            location?.pathname?.includes("manage-dashboard")
                              ? navigate(
                                  `/manage-dashboard/view-patient/${
                                    location.pathname.split("/")?.[3]
                                  }`
                                )
                              : navigate(
                                  `/manage-patients/view-patient/${
                                    location.pathname.split("/")?.[3]
                                  }`
                                );
                          }}
                                          className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff]
rounded-[16px] bg-[#972E4C] min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 `}
                        >
                                          Patient Details
                                      </button>
                                  </div>
                              </div>
                              {patientTabName === "Graphs" && isFetching ? (
                                  <div className="mt-10">
                                      <CustomOverLay
                                          Active
                                          text="Loading Graph Details..."
                                          classKey={`top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${
                            isSideBar
                              ? "opened_sidebar_overlay"
                              : "overlay-list1"
                          }`}
                        />
                                  </div>
                    ) : (
                      patientTabName === "Graphs" &&
                      !isFetching && (
                      <Graphs
                          setIsStateLoading={setIsStateLoading}
                          graphDetails={graphDetails}
                          graphLoader={graphLoader}
                          previousDay={previousDay}
                          nextDay={nextDay}
                          selectedDate={selectedDate}
                          handleSelectDate={handleSelectDate}
                          handleTodayClick={handleTodayClick}
                          patientData={patientData}
                          wellnessDetails={wellnessDetails}
                        />
                      )
                    )}
                              {patientTabName === "historical_data" && (
                              <HistoricalData
                                  setHistoricalDataLoading={setHistoricalDataLoading}
                      />
                    )}
                              {patientTabName === "device_alerts" && (
                              <DeviceAlertList
                                  setIsStateLoading={setIsStateLoading}
                                  wellnessDetails={wellnessDetails}
                                  wellnessFetching={isFetching}
                      />
                    )}

                              {patientTabName === "provider_alerts" && (
                              <div className="bg-white rounded-lg py-3 h-customh17 mt-[24px] relative">
                                  <div className="px-6 mt-[18px] flex justify-between mb-[10px]">
                                      {providerData && (
                                      <div className="flex justify-between items-center w-full">
                                          <h1 className="text-xl font-normal text-[#000000] 2xl:pt-0 pt-2 ">
                                              Provider Alerts
                                          </h1>
                                          <span
                                              onClick={() => setHelpGuideModel(true)}
                                              className=" ml-2 cursor-pointer"
                              >
                                              <img
                                                  src="/images/helpguideicon.png"
                                                  alt="icon"
                                                  loading="lazy"
                                                  decoding="async"
                                />
                                          </span>
                                      </div>
                          )}

                                      {(providerData?.data?.length > 0 ||
                            providerData?.total_count !== 0 ||
                            provideralertloading) && (
                            <div className="relative">
                                <FilterProviderAlertBtn
                                    dateError={dateError}
                                    setdateError={setdateError}
                                    isFilterOpen={isFilterOpen}
                                    setIsFilterOpen={setIsFilterOpen}
                                    handleApplyFilter={handleApplyFilter}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues}
                                    initialState={initialState}
                                    handleOpenFilter={handleOpenFilter}
                              />
                                {/* {(SearchInput || isExport) && data !== undefined && data?.data?.length > 0 && <div> <ActivityExportPatient
selectedRows={selectedRows}
exportObservers={exportObservers}
isExportList={isExportList}
exportCols={exportCols}
setIsFilterOpen={setIsFilterOpen}
isColumnSelect={isColumnSelect}
setIsColumnSelect={setIsColumnSelect}
isIdexport={isIdexport} username={username} />
</div>} */}
                            </div>
                          )}
                                  </div>
                                  {(provideralertfetching &&
                          provideralertstatus !== "fulfilled" &&
                          provideralertstatus !== "rejected" &&
                          !isAlertSortselected) ||
                        provideralertloading ||
                        (providerData === undefined &&
                          provideralertstatus !== "fulfilled" &&
                          provideralertstatus !== "rejected") ? (
                              <CustomOverLay
                                  Active
                                  text="Loading Provider Alert list..."
                                  classKey={`absolute top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${
                              isSideBar
                                ? "opened_sidebar_overlay_alert"
                                : "overlay-list_alert"
                            }`}
                          />
                        ) : providerData !== undefined &&
                          providerData?.data?.length > 0 ? (
                              <>
                                  <div className="px-6 mt-[20px]">
                                      <ProviderAlertTable
                                          setIsStateLoading={setIsStateLoading}
                                          pageNumber={
                                  Number(
                                    searchParamsAlert.get("page_number")
                                  ) || 1
                                }
                                          List={providerData}
                                          handleSearchParams={handleSearchParams}
                                          sortValue={searchParamsAlert.get("sort") || ""}
                                          setisAlertSortSelected={setisAlertSortSelected}
                                          patientId={patientId}
                              />
                                  </div>
                                  {providerData?.total_count >= 15 && (
                                  <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                                      <p className="text-sm font-semibold text-[#687182]">
                                          Total Number of Records:
                                          {Math.ceil(
                                    parseInt(providerData?.total_count)
                                  )}
                                      </p>
                                      <div className="flex items-center">
                                          <Limit
                                              limit={limit}
                                              setLimit={setLimit}
                                              handleNoOfRowsClick={handleNoOfRowsClick}
                                              isColumnSelect={isColumnSelect}
                                  />
                                          <Pagination
                                              TotalCount={parseInt(
                                      providerData?.total_count
                                    )}
                                              totalPageNumber={Math.ceil(
                                      parseInt(providerData?.total_count) /
                                        parseInt(
                                          searchParamsAlert?.get("limit")
                                        )
                                    )}
                                              handleOnClickPageNumber={
                                      handleOnClickPageNumber
                                    }
                                              limit={parseInt(limit)}
                                  />
                                      </div>
                                  </div>
                            )}
                              </>
                        ) : (
                            <>
                                {(providerData?.total_count === 0 &&
                              suggestions?.trim() !== "") ||
                            providerData?.success_status === "false" ||
                            searchParams.get("start_date") !== null ||
                            searchParams.get("end_date") !== null ? (
                                <SearchEmptyScreen
                                    welnesscontact={true}
                                    text={
                                  "That filter combination has no result. Please try different criteria"
                                }
                              />
                            ) : providerData?.total_count === 0 &&
                              !searchParams.get("search") ? (
                                  <Emptyscreen
                                      title={"Manage Patients"}
                                      provider={true}
                                      PatientNotes={true}
                                      FirstPTag={"No Provider Alerts yet ."}
                              />
                            ) : (
                              (provideralertstatus === "rejected" ||
                                (providerData?.total_count !== 0 &&
                                  providerData?.provider_alert?.length ===
                                    0)) && (
                                    <SearchEmptyScreen text={"No data found"} />
                              )
                            )}
                            </>
                        )}
                              </div>
                    )}
                              {patientTabName === "provider_list" && (
                              <div className="bg-white rounded-lg py-3 h-customh17 mt-[24px] relative">
                                  <div className="px-6 mt-[18px] mb-[23px]">
                                      <div className="flex justify-between items-center">
                                          <h1 className="text-xl font-normal text-[#000000] min-w-fit 2xl:pt-0 pt-2 self-start 2xl:self-center">
                                              Provider List
                                          </h1>
                                          <span
                                              onClick={() => setHelpGuideModel(true)}
                                              className=" ml-2 cursor-pointer"
                            >
                                              <img
                                                  src="/images/helpguideicon.png"
                                                  alt="icon"
                                                  loading="lazy"
                                                  decoding="async"
                              />
                                          </span>
                                      </div>
                                  </div>
                                  {(providerlistfetch &&
                          providerstatus !== "fulfilled" &&
                          providerstatus !== "rejected" &&
                          !isSortselected) ||
                        providerloading ||
                        (data === undefined &&
                          providerstatus !== "fulfilled" &&
                          providerstatus !== "rejected") ? (
                              <CustomOverLay
                                  Active
                                  text="Loading Provider list..."
                                  classKey={`absolute top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${
                              isSideBar
                                ? "opened_sidebar_overlay_alert"
                                : "overlay-list_alert"
                            }`}
                          />
                        ) : data !== undefined && data?.data?.length > 0 ? (
                            <>
                                <div className="px-6">
                                    <ProviderTable
                                        setIsStateLoading={setIsStateLoading}
                                        pageNumber={
                                  Number(searchParams.get("page_number")) || 1
                                }
                                        List={data}
                                        handleSearchParams={handleSearchParams}
                                        sortValue={searchParams.get("sort") || ""}
                                        setisSortSelected={setisSortSelected}
                                        patientId={patientId}
                              />
                                </div>
                                {data?.total_count >= 15 && (
                                <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                                    <p className="text-sm font-semibold text-[#687182]">
                                        Total Number of Records:
                                        {Math.ceil(parseInt(data?.total_count))}
                                    </p>
                                    <div className="flex items-center">
                                        <Limit
                                            limit={limit}
                                            setLimit={setLimit}
                                            handleNoOfRowsClick={handleNoOfRowsClick}
                                            isColumnSelect={isColumnSelect}
                                  />
                                        <Pagination
                                            TotalCount={parseInt(data?.total_count)}
                                            totalPageNumber={Math.ceil(
                                      parseInt(data?.total_count) /
                                        parseInt(searchParams?.get("limit"))
                                    )}
                                            handleOnClickPageNumber={
                                      handleOnClickPageNumber
                                    }
                                            limit={parseInt(limit)}
                                  />
                                    </div>
                                </div>
                            )}
                            </>
                        ) : (
                            <>
                                {(data?.total_count === 0 &&
                              suggestions?.trim() !== "") ||
                            data?.success_status === "false" ||
                            searchParams.get("start_date") !== null ||
                            searchParams.get("end_date") !== null ||
                            searchParams.get("organization_name") !== null ? (
                                <SearchEmptyScreen
                                    text={
                                  "No exact matches found. Please try a different search"
                                }
                              />
                            ) : data?.total_count === 0 &&
                              !searchParams.get("search") ? (
                                  <Emptyscreen
                                      title={"Manage Patients"}
                                      provider={true}
                                      PatientNotes={true}
                                      FirstPTag={"No Providers associated yet ."}
                              />
                            ) : (
                              (providerstatus === "rejected" ||
                                (data?.total_count !== 0 &&
                                  data?.data?.length === 0)) && (
                                  <SearchEmptyScreen text={"No data found"} />
                              )
                            )}
                            </>
                        )}
                              </div>
                    )}
                          </div>
                      </div>
                      {helpGuideModel && helpguidestatus === "fulfilled" && (
                      <HelpGuideModal
                          setHelpGuideModel={setHelpGuideModel}
                          pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                  />
                )}
                  </motion.div>
              </div>
          )}
              </>
          </div>
      </>
  );
}
